import { MAXIMUM_NUMBER_OF_RELATED_KEYWORD_LIST } from '../app/searchWordConstants';

/**
 *  중복된 키워드는 등록할 수 없습니다.
 */
export const INVALID_DUPLICATE_SEARCH_WORD_MESSAGE = '중복된 키워드는 등록할 수 없습니다.';

/**
 *  연관 키워드는 최대 10개까지 입력 가능합니다.
 */
export const INVALID_RELATED_KEYWORD_MAXIMUM_MESSAGE = `연관 키워드는 최대 ${MAXIMUM_NUMBER_OF_RELATED_KEYWORD_LIST}개까지 입력 가능합니다.`;
